import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { DescribedSelection } from './DescribedSelection';
import { DescribedSelectionFieldSchema } from './schema';

export const DescribedSelectionFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'DescribedSelection',
    component: DescribedSelection,
    schema: DescribedSelectionFieldSchema.schema,
  }),
);
